export * from "./fileImport"
export * from "./filesystem-observer"
export * from "./page"

export type WASM_METHODS = "toJSON" | "toString" | "free" | typeof Symbol.dispose

export enum Decorator {
  NOT_APPLICABLE,
  INVALID,
  VALID,
  VALID_GUESS,
}

export type Only<T, U> = {
  [P in keyof T]: T[P];
} & {
  [P in keyof U]?: never;
}

export type Either<T, U> = Only<T, U> | Only<U, T>
